<template>
	<div class="sideways-page-one">
		<!-- BEGIN PAGE BAR -->
		<div class="page-bar">
			<breadcrumb :crumbs="breadcrumbArray"></breadcrumb>
		</div>
		<div class="show-modal" v-if="showModal" @click="closeModal()" style="z-index:9999;position:fixed;top:0;left:0;height:100vh;width:100vw;display:flex;justify-content:center;align-items:center;background-color:rgba(0,0,0,0.5)">
			<div @click.stop style="background-color:white;border-radius:4px;width:700px;height:500px;padding:20px;align-items:center;display:flex;flex-direction:column">
				<h2> Select Day, Start time and Date range</h2>
				<div>
					<el-select v-model="multipleDays" placeholder="Select">
						<el-option
						v-for="(item, i) in days"
						:key="item"
						:label="item"
						:value="i">
						</el-option>
					</el-select>
				</div>
				<div>
					<el-time-picker
						v-model="startTime"
						placeholder="Select Start Time">
					</el-time-picker>
					<el-date-picker
						v-model="dateRange"
						type="datetimerange"
						range-separator=" - "
						placeholder="Select range"
						start-placeholder="Start date"
						end-placeholder="End date">
					</el-date-picker>
				</div>
				<div style="margin-top:20px">
					<el-button style="background-color:grey;pointer-events:none" :class="{'clickable-blue': multipleDays !== null && startTime !== null && dateRange !== null}" 
					@click="addLimitedTimePlaylist({start_time: timeFormat(startTime), presentation_id: selectedPresentation.presentation_id, day_of_week: multipleDays, playlist_type: 'one-time', start_datetime_range : dateFormat(dateRange[0]), end_datetime_range: dateFormat(dateRange[1])})" type="primary"> Add </el-button>
				</div>
			</div>
		</div>
		<!-- <h1 class="page-title">Layout</h1> -->
		<div v-if="step === 0" class="flex-center" >
			<div>
				<h1> Presentation Editor </h1>
			</div>
			<div>
				<el-button @click="createPres(), getLayouts()" style="width:25%" type="primary"> Create a new Presentation</el-button>
				<el-button @click="setStep(3), getPresentations()" style="width:25%" type="primary"> Open existing Presentation</el-button>
			</div>
		</div>
		<div v-if="step === 1" class="flex-center" >
			<div>
				<h1> Select a layout </h1>
			</div>
			<div>
				<!-- {{ layoutList }} -->
				<template v-for="(layout, index) in layoutList">
					<el-button @click="setActiveLayout(index)" style="width:25%" type="primary"> {{ layout.name }} w: {{layout.width}} h: {{layout.height}} </el-button>
					<!-- <el-button @click="deleteLayout(layout.layout_id, index)" type="danger"> Delete </el-button>  -->
					<br>
					<br>
				</template>
			</div>
		</div>
		<div v-if="step === 3" class="flex-center" >
			<div>
				<h1> Select a Presentation </h1>
			</div>
			<div>
				<template v-for="(pres, index) in presentationList">
					<el-button @click="selectPres(index)" style="width:25%" type="primary"> {{ pres.name }} </el-button>
					<el-button @click="deletePres(pres.presentation_id, index)" type="danger"> Delete </el-button>
					<br>
					<br>
				</template>
			</div>
		</div>
		<div v-if="step === 2" class="flex-center" >
		<div>
			<button @click="showAll()" class="button btn">
				<i class="fa fa-th fa-2x"></i>
				<br>
				Show all Displays
			</button>
			<button @click="showOne()" class="button btn">
				<i class="fa fa-stop fa-2x"></i>
				<br>
				Show One Display
			</button>
			<div>
				<h1> Presentation: {{ selectedPresentation.name }} </h1>
			</div>
		</div>
		<template v-if="displayNumber !== false">
			<div>
				<div>
					<h1> Layout: {{ name }} (Display {{ displayNumber + 1 }}/{{ displayCount }})</h1>
				</div>
				<button :disabled="!displayNumber > 0" @click="prevDisplay()" class="button btn">
					<i class="fa fa-chevron-left fa-2x"></i>
					<br>
					Previous Display
				</button>
				<button @click="toggle()" class="button btn">
					<i class="fa fa-arrows-alt fa-2x"></i>
					<br>
					Fullscreen
				</button>
				<button :disabled="!(this.displayNumber < this.displayCount - 1)" @click="nextDisplay()" class="button btn">
					<i class="fa fa-chevron-right fa-2x"></i>
					<br>
					Next Display
				</button>
			</div>
			<div style="width: auto!important;padding: 5px;" :style="{'margin-bottom': padding + 'px'}">
				<fs ref="fs" :fullscreen.sync="fullscreen">
					<div class="layout-editor" style="position: relative;transform-origin:top;outline: 5px solid black;" :style="{width: layoutWidth + 'px', height: layoutHeight + 'px', transform: 'scale(' + demoScale + ',' + demoScale + ')', 'background-size': grid + 'px ' + grid + 'px'}">
						<template v-if="region.background !== 'transparent' && region.screen === displayNumber && !region.limited" v-for="(region, i) in zones">
							<vue-draggable-resizable 
							@activated="selectPlaylist(i)" 
							:draggable="false" 
							:resizable="false" 
							:class="{'selected-playlist-text': selectedPlaylist === i, 'seethru': selectedPlaylist !== null && fullscreen === false}"
							:grid="[grid, grid]"
							:style="{'background-color': region.background}" :id="`region-${i}`" :index="i" class="demo-region" :x="region.x" :y="region.y" :w="region.width" :h="region.height" :z="region.z" :parent="true">
							<template v-if="regionList[i][regionFromTime(i, players[i])]">
								<template v-if="regionList[i][regionFromTime(i, players[i])].resource">
									<video :key="`video-${regionList[i][regionFromTime(i, players[i])].resource.url}`" class="autoPlayMe" v-if="regionList[i][regionFromTime(i, players[i])].resource.extension === 'mp4'" :width="region.width" :height="region.height" loop autoplay>
										<source :src="regionList[i][regionFromTime(i, players[i])].resource.url" type="video/mp4">
										Your browser does not support HTML5 video.
									</video>
									<div v-else-if="regionList[i][regionFromTime(i, players[i])].resource.extension === 'png' || regionList[i][regionFromTime(i, players[i])].resource.extension === 'jpg' || regionList[i][regionFromTime(i, players[i])].resource.extension === 'jpeg' || regionList[i][regionFromTime(i, players[i])].resource.extension === 'gif'"
									class="imageContainer"
									:style="{
									width: region.width + 'px',
									height: region.height + 'px',
									'background': 'url(' + regionList[i][regionFromTime(i, players[i])].resource.url + ')'
									}">
									</div>
									<div v-else-if="regionList[i][regionFromTime(i, players[i])].resource.extension === 'html'"
									style="background-color: white!important"
									v-html="regionList[i][regionFromTime(i, players[i])].resource.url"
									:style="{
									width: region.width + 'px',
									height: region.height + 'px',
									}">
									</div>
								</template>
								<span v-else style="flex-align:center;align-items:center;display: flex;flex-direction: column;background-color:rgba(0,0,0,0.5);color:white;border-radius: 4px;padding:1%;font-size:25px">
									<h1 style="margin-top:5%"> {{ region.name }} </h1>
									Group: {{ region.group }}
								</span>
							</template>
							<span v-else style="flex-align:center;align-items:center;display: flex;flex-direction: column;background-color:rgba(0,0,0,0.5);color:white;border-radius: 4px;padding:1%;font-size:25px">
								<h1 style="margin-top:5%"> {{ region.name }} </h1>
								Group: {{ region.group }}
							</span>
					   		</vue-draggable-resizable>
						</template>
					</div>
				</fs>
			</div>
			<div>
				<!-- <i  class="fa fa-plus" aria-hidden="true"></i> -->
				<button style="background-color:grey;pointer-events:none" :class="{'clickable-white': !play}" @click="addNewRegion()" class="button btn">
					<i class="fa fa-plus fa-2x"></i>
					<br>
					Add
				</button>

				<button style="background-color:grey;pointer-events:none" :class="{'clickable-white': !play}" @click="deleteRegion()" class="button btn">
					<i class="fa fa-minus fa-2x"></i>
					<br>
					Delete
				</button>

				<button @click="save(selectedPresentation.presentation_id)" class="button btn">
					<i class="fa fa-save fa-2x"></i>
					<br>
					Save
				</button>

				<button @click="setStep(0)" class="button btn">
					<i class="fa fa-undo fa-2x"></i>
					<br>
					Cancel
				</button>
				<resource-modal style="position:absolute;bottom:-10vh" id="invisible-button" :buttonText="'Select content'" @selected="selectedResource"></resource-modal> 
			</div>
			<div>
				<button  v-if="!play" @click="reset()" class="button btn">
					<i class="fa fa-play fa-2x"></i>
				</button>
				<button  v-if="play" @click="stop()" class="button btn">
					<i class="fa fa-stop fa-2x"></i>
				</button>
			</div>
			<div style="width:20%">
				Max Time (s) of playlist
				<el-slider v-model="maxTime" :step="5" show-input :min="10" :max="10000"></el-slider>
			</div>
			<div style="margin-bottom:50px">
				<div class="region-block" style="margin: 0 !important;display: inline-block;float: left;width:100px;">
					<div style="height:50px;width:100px">
						<button v-if="groupModeOn" @click="groupMode()" :style="{'background-color': colorHash('', selectedGroup)}"> <i class="fa fa-object-group"></i></button>
						<button v-else @click="groupMode()"> <i class="fa fa-object-group"></i></button>
					</div>
					<div :class="{'groupHover': groupModeOn}" 
						v-for="(region, j) in zones" 
						v-if="zones[j].screen === displayNumber" @click="selectPlaylist(j), groupToggle(j)" style="width:100%;display:inline-block;margin: 0;padding: 0;">
						<div style="display:flex;justify-content:center;align-items:center;flex-direction:row" class="row">
							<span v-if="region.group !== false" :style="{'background-color': colorHash('', region.group)}" style="width:10%;top:0;left:0;height:50px;border:1px solid black;">
								
							</span>
							<span v-else style="width:10%;top:0;left:0;height:50px;background-color:transparent;">
							</span>
							<p style="margin-left:0;margin-top:0;margin-bottom:0;margin-right: 15px;width:90%;flex-direction:column;display: flex;justify-content: center;align-items: center;background-color:white;padding: 0;line-height:20px;height:50px;opacity:0.5" :style="{'background-color': zones[j].background}" :class="{'selected-playlist-text': selectedPlaylist === j}"> 
								<span v-if="!region.limited" style="flex-align:center;align-items:center;display: flex;flex-direction: column;background-color:rgba(0,0,0,0.5);color:white;border-radius: 2px;padding:2px;">
									{{ region.name }} 
								</span>
								<!-- <button v-if="!region.limited" style="color:black" @click="showLimitedModal(j)"> + </button> -->
								<el-tooltip v-if="region.limited" class="item" effect="dark" 
								:content="days[region.limited.day_of_week] + ' one time at ' + region.limited.start_time + ' ' + region.limited.start_datetime_range + ' to ' + region.limited.end_datetime_range"
								placement="top-start">
									<span style="flex-align:center;align-items:center;display: flex;flex-direction: column;background-color:rgba(0,0,0,0.5);color:white;border-radius: 2px;padding:2px;">
										{{ region.name }}: {{ daysShort[region.limited.day_of_week] }} 
									</span>
								</el-tooltip>
								<button v-if="region.limited" style="color:black" @click="removePlaylist(j)"> - </button>
							</p>
						</div>
					</div>
				</div>
				<div class="playlist-block" style="white-space:nowrap;overflow-x: auto;overflow-y: hidden;">
					<div class="playlist" 
						:style="{
							width: maxTime * scale + 'px',
							'background-size': scale + 'px ' + height + 'px'
							}" 
						style="
							height:50px;
							background-image: linear-gradient(to right, lightgrey 1px, transparent 1px),linear-gradient(to bottom, transparent 1px, transparent 1px);
							position: relative;
							transform-origin:top;
							outline: 1px solid transparent;">
						<!-- <el-slider v-model="player" :min="0" :max="maxTime" :show-tooltip="false"></el-slider> -->
						<span :class="{'floatLeft': i !== maxTime}" v-for="(n, i) in maxTime + 1" v-if="(n - 1) % 10 === 0 || (n - 1) % 5 === 0" style="text-align:left;z-index:9;left:0;position:relative" :style="{width: scale * 5 + 'px'}">
							<span style="margin-left:2px"> {{n - 1}}s </span>
							<span v-if="(n - 1) % 10 === 0" style="position: absolute;left:0;height: 30px;border-left:1px solid black"></span>
							<span v-else-if="(n - 1) % 5 === 0" style="position: absolute;left:0;height: 20px;border-left:1px solid black"></span>
						</span>
					</div>
					<div v-for="(regions, j) in regionList" v-if="zones[j].screen === displayNumber" class="playlist" :style="{width: maxTime * scale + 'px', 'background-size': scale + 'px ' + height + 'px'}" style="height:50px;background-image: linear-gradient(to right, lightgrey 1px, transparent 1px), linear-gradient(to bottom, transparent 1px, transparent 1px);position: relative;transform-origin:top;outline: 1px solid transparent;" >
						<el-slider v-if="zones[j].group === false" v-model="players[j]" :min="0" :max="maxTime" :show-tooltip="false"></el-slider>
						<el-slider v-else v-model="players[getIndexOfStartGroup(zones[j].group)]" :min="0" :max="maxTime" :show-tooltip="false"></el-slider>
						<template v-for="(region, i) in regions">
							<vue-draggable-resizable 
								v-if="region.del !== true" 
								:class="{
									'selected-playlist': selectedPlaylist === j,
									'selected-region': selectedRegion === i && selectedPlaylist === j
									}"
								:draggable="false"
								@mouseOver="hoverButton"
								@mouseLeave="leaveButton"
								@resizing="onResize"  
								:grid="[scale, height]" 
								style="
									border:1px solid grey;
									display:flex;
									justify-content:center;
									align-items:center;
									height:50px;
									background-color:white" 
								:minw="scale" 
								:id="`region-${j}-${i}`" 
								:playlist="j" 
								:index="i" 
								@click.stop.prevent 
								:z.sync="region.z" 
								:x.sync="region.x" 
								:y="region.y" 
								:w.sync="region.width" 
								class="region" 
								:parent="true">
								<template v-if="region.resource">
									<video :key="`thumb-${region.resource.url}`" v-if="region.resource.extension === 'mp4'" :width="region.width" :height="50" loop>
										<source :src="region.resource.url" type="video/mp4">
										Your browser does not support HTML5 video.
									</video>
									<div v-else-if="region.resource.extension === 'png' || region.resource.extension === 'jpg' || region.resource.extension === 'jpeg' || region.resource.extension === 'gif'"
									class="imageContainer"
									:style="{
									width: region.width + 'px',
									height: 50 + 'px',
									'background': 'url(' + region.resource.url + ')'
									}">
									</div>
									<div v-else-if="region.resource.extension === 'html'"
									style="background-color: white!important"
									v-html="region.resource.url"
									:style="{
									width: region.width + 'px',
									height: region.height + 'px',
									}">
									</div>
									<div v-show="showButtons[0] === i && showButtons[1] === j" style="border-radius:2px;padding:2px;position:absolute;bottom:25px;color:white;background-color: rgba(0, 0, 0, 0.5);">  {{ parseInt(region.x / scale) }}-{{ parseInt((region.x / scale) + (region.width / scale)) }} </div>
									<button v-show="showButtons[0] === i && showButtons[1] === j" style="position:absolute;bottom:0;width: 30px;font-size: 10px;padding: 0;height: 25px;" class="btn button" @click="clickInvisibleButton(j, i)"> <i class="fa fa-2x fa-upload" style="color:black"></i> </button>
								</template>
								<div v-else-if="region.width > 30" style="display:flex;flex-direction:column">
								  {{ parseInt(region.x / scale) }}-{{ parseInt((region.x / scale) + (region.width / scale)) }}
									<button style="width: 30px;font-size: 10px;padding: 0;height: 25px;" class="btn button" @click="clickInvisibleButton(j, i)"> <i class="fa fa-2x fa-upload" style="color:black"></i> </button>
								</div>
							</vue-draggable-resizable>
						</template>
					</div>
				</div>
			</div>

			</template>
			
			<template v-else>
			<div style="display:flex;justify-content:center;align-items:center;flex-direction:column">
				<div>
					<h1> Layout: {{ name }} {{actualWidth}} x {{ layoutHeight}}</h1>
				</div>
				<button @click="toggle()" class="button btn">
					<i class="fa fa-arrows-alt fa-2x"></i>
					<br>
					Fullscreen
				</button>
			</div>
			<div v-loading="loading" style="width: auto!important;padding: 5px;" :style="{'margin-bottom': padding + 'px'}">
				<fs ref="fs" :fullscreen.sync="fullscreen">
					<div class="layout-editor" style="position: relative;transform-origin:top;outline: 5px solid black;" :style="{width: actualWidth + 'px', height: layoutHeight + 'px', transform: 'scale(' + demoScale + ',' + demoScale + ')', 'background-size': grid + 'px ' + grid + 'px'}">
						<template v-if="region.background !== 'transparent' && !region.limited" v-for="(region, i) in zones">
							<vue-draggable-resizable 
							@activated="selectPlaylist(i)"
							@mouseOver="hoverButton"
							:draggable="false" 
							:resizable="false" 
							:class="{'selected-playlist-text': selectedPlaylist === i, 'seethru': selectedPlaylist !== null && fullscreen === false}"
							:grid="[grid, grid]"
							:style="{'background-color': region.background}" :id="`region-${i}`" :index="i" class="demo-region" :x="region.actual_x" :y="region.y" :w="region.width" :h="region.height" :z="region.z" :parent="true">
							<template v-if="regionList[i][regionFromTime(i, players[i])]">
								<template v-if="regionList[i][regionFromTime(i, players[i])].resource">
									<video :key="`video-${regionList[i][regionFromTime(i, players[i])].resource.url}`" class="autoPlayMe" v-if="regionList[i][regionFromTime(i, players[i])].resource.extension === 'mp4'" :width="region.width" :height="region.height" loop autoplay>
										<source :src="regionList[i][regionFromTime(i, players[i])].resource.url" type="video/mp4">
										Your browser does not support HTML5 video.
									</video>
									<div v-else-if="regionList[i][regionFromTime(i, players[i])].resource.extension === 'png' || regionList[i][regionFromTime(i, players[i])].resource.extension === 'jpg' || regionList[i][regionFromTime(i, players[i])].resource.extension === 'jpeg' || regionList[i][regionFromTime(i, players[i])].resource.extension === 'gif'"
									class="imageContainer"
									:style="{
									width: region.width + 'px',
									height: region.height + 'px',
									'background': 'url(' + regionList[i][regionFromTime(i, players[i])].resource.url + ')'
									}">
									</div>
									<div v-else-if="regionList[i][regionFromTime(i, players[i])].resource.extension === 'html'"
									style="background-color: white!important"
									v-html="regionList[i][regionFromTime(i, players[i])].resource.url"
									:style="{
									width: region.width + 'px',
									height: region.height + 'px',
									}">
									</div>
								</template>
								<span v-else style="flex-align:center;align-items:center;display: flex;flex-direction: column;background-color:rgba(0,0,0,0.5);color:white;border-radius: 4px;padding:1%;font-size:25px">
									<h1 style="margin-top:5%"> {{ region.name }} </h1>
									Group: {{ region.group }}
								</span>
							</template>
							<span v-else style="flex-align:center;align-items:center;display: flex;flex-direction: column;background-color:rgba(0,0,0,0.5);color:white;border-radius: 4px;padding:1%;font-size:25px">
								<h1 style="margin-top:5%"> {{ region.name }} </h1>
								Group: {{ region.group }}
							<!--	<resource-modal id="invisible-button" :buttonText="'Select content'" @selected="selectedResource"></resource-modal> 
							-->
							</span>
					   		</vue-draggable-resizable>
						</template>
					</div>
				</fs>
			</div>
			<div>
				<!-- <i  class="fa fa-plus" aria-hidden="true"></i> -->
				<button style="background-color:grey;pointer-events:none" :class="{'clickable-white': !play}" @click="addNewRegion()" class="button btn">
					<i class="fa fa-plus fa-2x"></i>
					<br>
					Add
				</button>

				<button style="background-color:grey;pointer-events:none" :class="{'clickable-white': !play}"@click="deleteRegion()" class="button btn">
					<i class="fa fa-minus fa-2x"></i>
					<br>
					Delete
				</button>

				<button @click="save(selectedPresentation.presentation_id)" class="button btn">
					<i class="fa fa-save fa-2x"></i>
					<br>
					Save
				</button>

				<button @click="setStep(0)" class="button btn">
					<i class="fa fa-undo fa-2x"></i>
					<br>
					Cancel
				</button>
				<resource-modal style="position:absolute;bottom:-10vh" id="invisible-button" :buttonText="'Select content'" @selected="selectedResource"></resource-modal> 
			</div>
			<div>
				<button  v-if="!play" @click="reset()" class="button btn">
					<i class="fa fa-play fa-2x"></i>
				</button>
				<button  v-if="play" @click="stop()" class="button btn">
					<i class="fa fa-stop fa-2x"></i>
				</button>
			</div>
			<div style="width:20%">
				Max Time (s) of playlist
				<el-slider v-model="maxTime" :step="5" show-input :min="10" :max="10000"></el-slider>
			</div>

			<div style="margin-bottom:50px" v-loading="loading">
				<div class="region-block" style="margin: 0 !important;display: inline-block;float: left;width:100px;">
					<div style="height:50px;width:100px">
						<button v-if="groupModeOn" @click="groupMode()" :style="{'background-color': colorHash('', selectedGroup)}"> <i class="fa fa-object-group"></i></button>
						<button v-else @click="groupMode()"> <i class="fa fa-object-group"></i></button>
					</div>
					<div :class="{'groupHover': groupModeOn}" 
						v-for="(region, j) in zones" 
						@click="selectPlaylist(j), groupToggle(j)" style="width:100%;display:inline-block;margin: 0;padding: 0;">
						<div style="display:flex;justify-content:center;align-items:center;flex-direction:row" class="row">
							<span v-if="region.group !== false" :style="{'background-color': colorHash('', region.group)}" style="width:10%;top:0;left:0;height:50px;border:1px solid black;">
								
							</span>
							<span v-else style="width:10%;top:0;left:0;height:50px;background-color:transparent;">
							</span>
							<p style="margin-left:0;margin-top:0;margin-bottom:0;margin-right: 15px;width:90%;flex-direction:column;display: flex;justify-content: center;align-items: center;background-color:white;padding: 0;line-height:20px;height:50px;opacity:0.5" :style="{'background-color': zones[j].background}" :class="{'selected-playlist-text': selectedPlaylist === j}"> 
								<span v-if="!region.limited" style="flex-align:center;align-items:center;display: flex;flex-direction: column;background-color:rgba(0,0,0,0.5);color:white;border-radius: 2px;padding:2px;">
									{{ region.name }} 
								</span>
								<!-- <button  v-if="!region.limited" style="color:black" @click="showLimitedModal(j)"> + </button> -->
								<el-tooltip v-if="region.limited" class="item" effect="dark" 
								:content="days[region.limited.day_of_week] + ' one time at ' + region.limited.start_time + ' ' + region.limited.start_datetime_range + ' to ' + region.limited.end_datetime_range"
								placement="top-start">
									<span style="flex-align:center;align-items:center;display: flex;flex-direction: column;background-color:rgba(0,0,0,0.5);color:white;border-radius: 2px;padding:2px;">
										{{ region.name }}: {{ daysShort[region.limited.day_of_week] }} 
									</span>
								</el-tooltip>
								<button v-if="region.limited" style="color:black" @click="removePlaylist(j)"> - </button>
							</p>
						</div>
					</div>
				</div>
				<div class="playlist-block" style="white-space:nowrap;overflow-x: auto;overflow-y: hidden;">
					<div class="playlist" 
						:style="{
							width: maxTime * scale + 'px',
							'background-size': scale + 'px ' + height + 'px'
							}" 
						style="
							height:50px;
							background-image: linear-gradient(to right, lightgrey 1px, transparent 1px),linear-gradient(to bottom, transparent 1px, transparent 1px);
							position: relative;
							transform-origin:top;
							outline: 1px solid transparent;">
						<!-- <el-slider v-model="player" :min="0" :max="maxTime" :show-tooltip="false"></el-slider> -->
						<span :class="{'floatLeft': i !== maxTime}" v-for="(n, i) in maxTime + 1" v-if="(n - 1) % 10 === 0 || (n - 1) % 5 === 0" style="text-align:left;z-index:9;left:0;position:relative" :style="{width: scale * 5 + 'px'}">
							<span style="margin-left:2px"> {{n - 1}}s </span>
							<span v-if="(n - 1) % 10 === 0" style="position: absolute;left:0;height: 30px;border-left:1px solid black"></span>
							<span v-else-if="(n - 1) % 5 === 0" style="position: absolute;left:0;height: 20px;border-left:1px solid black"></span>
						</span>
					</div>
					<div v-for="(regions, j) in regionList" class="playlist" :style="{width: maxTime * scale + 'px', 'background-size': scale + 'px ' + height + 'px'}" style="height:50px;background-image: linear-gradient(to right, lightgrey 1px, transparent 1px), linear-gradient(to bottom, transparent 1px, transparent 1px);position: relative;transform-origin:top;outline: 1px solid transparent;" >
						<el-slider v-if="zones[j].group === false" v-model="players[j]" :min="0" :max="maxTime" :show-tooltip="false"></el-slider>
						<el-slider v-else v-model="players[getIndexOfStartGroup(zones[j].group)]" :min="0" :max="maxTime" :show-tooltip="false"></el-slider>
						<template v-for="(region, i) in regions">
							<vue-draggable-resizable 
								v-if="region.del !== true" 
								:class="{
									'selected-playlist': selectedPlaylist === j,
									'selected-region': selectedRegion === i && selectedPlaylist === j
									}"
								:draggable="false"
								@mouseOver="hoverButton"
								@mouseLeave="leaveButton"
								@resizing="onResize"  
								:grid="[scale, height]" 
								style="
									border:1px solid grey;
									display:flex;
									justify-content:center;
									align-items:center;
									height:50px;
									background-color:white" 
								:minw="scale" 
								:id="`region-${j}-${i}`" 
								:playlist="j" 
								:index="i" 
								@click.stop.prevent 
								:z.sync="region.z" 
								:x.sync="region.x" 
								:y="region.y" 
								:w.sync="region.width" 
								class="region" 
								:parent="true">
								<template v-if="region.resource">
									<video :key="`thumb-${region.resource.url}`" v-if="region.resource.extension === 'mp4'" :width="region.width" :height="50" loop>
										<source :src="region.resource.url" type="video/mp4">
										Your browser does not support HTML5 video.
									</video>
									<div v-else-if="region.resource.extension === 'png' || region.resource.extension === 'jpg' || region.resource.extension === 'jpeg' || region.resource.extension === 'gif'"
									class="imageContainer"
									:style="{
									width: region.width + 'px',
									height: 50 + 'px',
									'background': 'url(' + region.resource.url + ')'
									}">
									</div>
									<div v-else-if="region.resource.extension === 'html'"
									style="background-color: white!important"
									v-html="region.resource.url"
									:style="{
									width: region.width + 'px',
									height: region.height + 'px',
									}">
									</div>
									<div v-show="showButtons[0] === i && showButtons[1] === j" style="border-radius:2px;padding:2px;position:absolute;bottom:25px;color:white;background-color: rgba(0, 0, 0, 0.5);">  {{ parseInt(region.x / scale) }}-{{ parseInt((region.x / scale) + (region.width / scale)) }} </div>
									<button v-show="showButtons[0] === i && showButtons[1] === j" style="position:absolute;bottom:0;width: 30px;font-size: 10px;padding: 0;height: 25px;" class="btn button" @click="clickInvisibleButton(j, i)"> <i class="fa fa-2x fa-upload" style="color:black"></i> </button>
								</template>
								<div v-else-if="region.width > 30" style="display:flex;flex-direction:column">
								  {{ parseInt(region.x / scale) }}-{{ parseInt((region.x / scale) + (region.width / scale)) }}
									<button style="width: 30px;font-size: 10px;padding: 0;height: 25px;" class="btn button" @click="clickInvisibleButton(j, i)"> <i class="fa fa-2x fa-upload" style="color:black"></i> </button>
								</div>
							</vue-draggable-resizable>
						</template>
					</div>
				</div>
			</div>
			</template>
		</div>
	</div>
</template>

<script>
	import Breadcrumb from '../../modules/Breadcrumb'
	import $ from 'jquery'
	import VueDraggableResizable from '../../modules/vue-draggable-resizable'
	import Selector from '../../modules/selector'
	import Fullscreen from 'vue-fullscreen'
	import Vue from 'vue'
	import draggable from 'vuedraggable'
	import Signage from '../../../controllers/Signage'
	import md5 from 'md5'
	import ResourceModal from '../../modules/ResourceModal.vue'
	import Resource from '../../../controllers/Resources'
	import {mapGetters} from 'vuex'

	Vue.use(Fullscreen, {name: 'fs'})
	export default {
		data () {
			return {
				loadedSavedData: false,
				groups: [],
				selectedGroup: null,
				timer: null,
				player: 0,
				play: false,
				startVal: 0,
				endVal: 0,
				step: 0,
				scale: 10,
				demoScale: 0.5,
				grid: 10,
				oldScale: 10,
				maxTime: 120,
				note: 'Signage Layout',
				breadcrumbArray: [
					{name: 'UNOapp Signage', link: false},
					{name: 'Presentation Editor', link: false}
				],
				layoutId: 0,
				displayCount: 1,
				displayNumber: 0,
				layoutHeight: 1080,
				layoutWidth: 1920,
				selectedRegion: 0,
				selectedPlaylist: 0,
				zones: [],
				name: '',
				regionList: [],
				layoutList: [],
				regionNames: [],
				padding: 0,
				height: 50,
				animationStep: null,
				fullscreen: false,
				beforeFullscreen: null,
				players: [],
				actualWidth: 0,
				loading: false,
				groupModeOn: false,
				showButtons: false,
				presentationList: [],
				selectedPresentation: {},
				nowPlaying: [[]],
				showModal: false,
				startTime: null,
				dateRange: null,
				multipleDays: null,
				daysShort: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
				days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
				selectedPlaylistIndex: 0,
				limited: [],
				limitedZones: [],
				limitedRegion: []
			}
		},
		computed: mapGetters([
			'activeLocationId',
			'activeBusinessId'
		]),
		components: {
			Breadcrumb,
			VueDraggableResizable,
			draggable,
			Selector,
			ResourceModal
		},
		methods: {
			padZero (val) {
				let a
				if (val < 10) {
					a = '0' + val
				} else {
					a = val
				}
				return a
			},
			timeFormat (date) {
				let utc = this.padZero(date.getHours()) + ':' + this.padZero(date.getMinutes()) + ':' + this.padZero(date.getSeconds())
				return utc
			},
			dateFormat (date) {
				let utc = date.getUTCFullYear() + '-' + this.padZero(date.getUTCMonth()) + '-' + this.padZero(date.getUTCDay()) + ' ' + this.padZero(date.getUTCHours()) + ':' + this.padZero(date.getUTCMinutes()) + ':' + this.padZero(date.getUTCSeconds())
				console.log(utc)
				return utc
			},
			getIndexOfStartGroup (groupId) {
				var val = 0
				var maxTime = 0
				this.regionList.forEach((x, i) => {
					x.forEach(y => {
						if (this.zones[i].group === groupId && (y.x / this.scale + y.width / this.scale) > maxTime) {
							val = i
							maxTime = y.x / this.scale + y.width / this.scale
						}
					})
				})
				return val
			},
			showLimitedModal (i) {
				console.log(i)
				this.selectedPlaylistIndex = i
				this.showModal = true
			},
			addLimitedTimePlaylist (obj) {
				console.log(obj)
				let newZone = JSON.parse(JSON.stringify(this.zones[this.selectedPlaylistIndex]))
				newZone.limited = obj
				newZone.group = false
				// this.limitedZones.push(newZone)
				// this.limitedRegion.push([])
				this.zones.splice(this.selectedPlaylistIndex + 1, 0, newZone)
				this.regionList.splice(this.selectedPlaylistIndex + 1, 0, [])
				console.log(this.regionList)
				console.log(this.zones)
				this.$forceUpdate()
				this.closeModal()
			},
			removePlaylist (i) {
				this.zones.splice(i, 1)
				this.regionList.splice(i, 1)
			},
			closeModal () {
				this.showModal = false
				this.startTime = null
				this.dateRange = null
				this.multipleDays = null
			},
			getResource (id) {
				return Resource.getResource(this.activeBusinessId, this.activeLocationId, id).then(response => {
					return response.payload.file
				}).catch(e => {
				})
			},
			createLayoutPlaylist (id) {
				let obj = {
					presentation_id: id,
					playlist_type: 'default'
				}
				return Signage.createLayoutPlaylist(obj).then(response => {
					this.createLayoutPlaylistEntry(response.payload.playlist_id)
				}).catch(e => {
					this.getLayoutPlaylist()
				})
			},
			getLayoutPlaylist () {
				let obj = {
					presentation_id: this.selectedPresentation.presentation_id
				}
				return Signage.getLayoutPlaylists(obj).then(response => {
					this.createLayoutPlaylistEntry(response.payload.playlist_id)
				}).catch(e => {
				})
			},
			getLayoutPlaylistEntries (id) {
				return Signage.getLayoutPlaylistEntries(id).then(response => {
					response.payload.entries.forEach(x => {
						this.deleteLayoutPlaylistEntry(x.entry_id)
					})
				}).catch(e => {
				})
			},
			deleteLayoutPlaylistEntry (id) {
				return Signage.deleteLayoutPlaylistEntry(id).then(response => {
					console.log(response)
				}).catch(e => {
				})
			},
			createLayoutPlaylistEntry (id) {
				this.getLayoutPlaylistEntries(id)
				let obj = {
					playlist_id: id,
					layout_id: this.layoutId,
					start_time: 0
				}
				return Signage.createLayoutPlaylistEntry(obj).then(response => {
					console.log('done')
				}).catch(e => {
				})
			},
			saveToDb (id) {
				var obj = {
					playlist_type: 'default',
					presentation_id: id
				}
				this.createLayoutPlaylist(id)
				let temp = JSON.parse(JSON.stringify(this.regionList))
				let a = []
				let b = []
				b = this.regionList.map(x => [])
				temp.forEach((x, i) => {
					console.log(x)
					if (this.zones[i].group === false) {
						a.push(x)
						a.forEach((y, j) => {
							a[j].forEach((z, k) => {
								if (!a[j][k].zone_id) {
									a[j][k].zone_id = this.zones[i].zone_id
								}
								if (!a[j][k].limited) {
									a[j][k].limited = this.zones[i].limited
								}
							})
						})
					} else {
						console.log(this.zones[i])
						b[this.zones[i].group].push(...x)
						b[this.zones[i].group].forEach((x, j) => {
							if (!b[this.zones[i].group][j].zone_id) {
								b[this.zones[i].group][j].zone_id = this.zones[i].zone_id
							}
							if (!b[this.zones[i].group][j].limited) {
								b[this.zones[i].group][j].limited = this.zones[i].limited
							}
						})
					}
				})
				// b = b.map(x => {
				// 	x.forEach(x => {
				// 		a.push(x)
				// 	})
				// 	return a
				// })
				console.log('a:', a)
				console.log('b:', b)
				a.forEach((x, i) => {
					console.log(x)
					if (x[0]) {
						if (x[0].limited) {
							obj.playlist_type = x[0].limited.playlist_type
							obj.start_time = x[0].limited.start_time
							obj.start_datetime_range = x[0].limited.start_datetime_range
							obj.end_datetime_range = x[0].limited.end_datetime_range
							obj.day_of_week = x[0].limited.day_of_week
						}
					}
					console.log(obj)
					Signage.createPlaylist(obj).then(response => {
						x.forEach(y => {
							console.log(y)
							let type = 'image'
							let entry = {}
							if (y.resource) {
								if (y.resource.extension === 'mp4' || y.resource.extension === 'webm' || y.resource.extension === 'ogg') {
									type = 'video'
								}
								entry = {
									playlist_id: response.payload.playlist_id,
									zone_id: y.zone_id,
									content_id: y.resource.id,
									content_url: y.resource.url,
									content_type: type,
									loop: 1,
									play_once: 0,
									muted: 1,
									start_time: parseInt(y.x / this.scale) * 1000,
									duration: parseInt(y.width / this.scale) * 1000
								}
							} else {
								entry = {
									playlist_id: response.payload.playlist_id,
									zone_id: y.zone_id,
									content_id: 1,
									content_type: 'none',
									content_url: 'none',
									loop: 1,
									play_once: 0,
									muted: 1,
									start_time: parseInt(y.x / this.scale) * 1000,
									duration: parseInt(y.width / this.scale) * 1000
								}
							}
							Signage.createPlaylistEntry(entry).then(response => {
								// let playlistId = response.payload.playlist_id
							})
						})
					})
				})
				b.forEach((x, i) => {
					if (x[0]) {
						if (x[0].limited) {
							obj.playlist_type = x[0].limited.playlist_type
							obj.start_time = x[0].limited.start_time
							obj.start_datetime_range = x[0].limited.start_datetime_range
							obj.end_datetime_range = x[0].limited.end_datetime_range
							obj.day_of_week = x[0].limited.day_of_week
						}
					}
					console.log(obj)
					Signage.createPlaylist(obj).then(response => {
						x.forEach(y => {
							console.log(y)
							console.log(this.zones)
							let type = 'image'
							let entry = {}
							if (y.resource) {
								if (y.resource.extension === 'mp4' || y.resource.extension === 'webm' || y.resource.extension === 'ogg') {
									type = 'video'
								}
								entry = {
									playlist_id: response.payload.playlist_id,
									zone_id: y.zone_id,
									content_id: y.resource.id,
									content_type: type,
									content_url: y.resource.url,
									loop: 1,
									play_once: 0,
									muted: 1,
									start_time: parseInt(y.x / this.scale) * 1000,
									duration: parseInt(y.width / this.scale) * 1000
								}
							} else {
								entry = {
									playlist_id: response.payload.playlist_id,
									zone_id: y.zone_id,
									content_id: 1,
									content_type: 'none',
									content_url: 'none',
									loop: 1,
									play_once: 0,
									muted: 1,
									start_time: parseInt(y.x / this.scale) * 1000,
									duration: parseInt(y.width / this.scale) * 1000
								}
							}
							Signage.createPlaylistEntry(entry).then(response => {
								// let playlistId = response.payload.playlist_id
							})
						})
					})
				})
				this.$notify({
					title: 'Presentation Saved',
					message: 'Presentation Saved successfully',
					type: 'success'
				})
			},
			save (id) {
				this.deleteAllPlaylists(id).then(x => {
					this.saveToDb(id)
				})
			},
			selectPres (i) {
				this.selectedPresentation = this.presentationList[i]
				console.log(this.selectedPresentation)
				this.getLayouts()
				this.loadedSavedData = true
				this.setStep(1)
			},
			createPres () {
				this.$prompt('Name this presentation', 'Presentation', {
					confirmButtonText: 'OK',
					cancelButtonText: 'Cancel',
					inputErrorMessage: 'Invalid Name'
				}).then(value => {
					this.createPresentation(value.value)
				}).then(x => {
					this.setStep(1)
				}).catch(() => {
				})
			},
			deletePres (id, i) {
				return Signage.deletePresentation(id).then(response => {
					console.log(response)
					this.presentationList.splice(i, 1)
				}).catch(e => {
				})
			},
			createPresentation (str) {
				return Signage.createPresentation(str, this.activeLocationId).then(response => {
					console.log(response)
					this.selectedPresentation = {
						presentation_id: response.payload.presentation_id,
						name: str
					}
				}).catch(e => {
				})
			},
			getPresentations () {
				return Signage.getPresentations(this.activeLocationId).then(response => {
					this.presentationList = response.payload.presentations
					console.log(response)
				}).catch(e => {
				})
			},
			getPlaylists (id) {
				return Signage.getPlaylists(id).then(response => {
					response.payload.playlists.forEach((x, i) => {
						this.getPlaylistEntries(x.playlist_id, i, x)
					})
				}).catch(e => {
				})
			},
			deleteAllPlaylists (id) {
				return Signage.getPlaylists(id).then(response => {
					response.payload.playlists.forEach((x, i) => {
						this.deletePlaylist(x.playlist_id)
					})
				}).catch(e => {
				})
			},
			getPlaylistEntries (id, i, playlist) {
				var group = false
				return Signage.getPlaylistEntries(id).then(response => {
					console.log(response)
					if (response.payload.entries.length > 1) {
						group = i
					}
					response.payload.entries.forEach((y, j) => {
						this.zones.forEach((x, i) => {
							if (y.zone_id === x.zone_id) {
								console.log(y)
								console.log(playlist)
								this.regionList[i].push({
									height: 50,
									width: y.duration / 1000 * this.scale,
									x: y.start_time / 1000 * this.scale,
									y: 0,
									z: 0,
									content: {
										type: y.content_type,
										id: y.content_id
									},
									background: 'white',
									del: false,
									group: group,
									id: y.entry_id,
									limited: playlist,
									type: playlist.playlist_type
								})
								this.zones[i].group = group
							}
						})
					})
					this.regionList = this.regionList.map((y, i) => {
						return y.map(x => {
							let obj = x
							console.log(x)
							if (x.content) {
								if (x.content.type !== 'none') {
									this.getResource(x.content.id).then(z => {
										delete obj.content
										obj.resource = z
									})
								} else {
									delete obj.content
								}
							}
							return obj
						})
					})
					// for (let i = 0; i < this.regionList.length; i++) {
					// 	for (let j = 0; j < this.regionList[i]; j++) {
					// 		if (this.regionList[i][j].type === 'one-time') {
					// 		} else {
					// 		}
					// 	}
					// }
					// if (x.type === 'one-time') {
					// 	return false
					// } else {
					// 	return obj
					// }
					// console.log(this.zones[i])
					// let newZone = JSON.parse(JSON.stringify(this.zones[i]))
					// newZone.limited = obj.limited
					// this.zones.splice(i + 1, 0, newZone)
					// delete obj.limited
					// delete obj.type
					this.start()
					// setTimeout(() => {
					// 	this.stop()
					// }, 1500)
					console.log(this.regionList)
				}).catch(e => {
					console.log(e)
					this.deletePlaylist(id)
				})
			},
			deletePlaylist (id) {
				return Signage.deletePlaylist(id).then(response => {
				}).catch(e => {
					console.log(id)
				})
			},
			hoverButton (i, j) {
				this.showButtons = [i, j]
				// this.deleteQueue()
			},
			leaveButton () {
				this.showButtons = false
			},
			regionFromTime (i, time) {
				var value = 0
				// console.log(this.zones[i].group)
				if (this.zones[i].group === false) {
					// console.log('group: false')
					for (let j = 0; j < this.regionList[i].length; j++) {
						if (this.regionList[i][j].x / this.scale < time && time < (this.regionList[i][j].x / this.scale + this.regionList[i][j].width / this.scale)) {
							value = j
						}
					}
				} else {
					// console.log('group: true')
					for (let j = 0; j < this.regionList[this.getIndexOfStartGroup(this.zones[i].group)].length; j++) {
						if (this.regionList[this.getIndexOfStartGroup(this.zones[i].group)][j].x / this.scale < this.players[this.getIndexOfStartGroup(this.zones[i].group)] && this.players[this.getIndexOfStartGroup(this.zones[i].group)] < (this.regionList[this.getIndexOfStartGroup(this.zones[i].group)][j].x / this.scale + this.regionList[this.getIndexOfStartGroup(this.zones[i].group)][j].width / this.scale)) {
							value = j
						}
					}
				}
				return value
			},
			showOne () {
				this.displayNumber = 0
				this.demoScale = 0.5
				this.loading = true
				this.getZones()
			},
			showAll () {
				this.displayNumber = false
				this.loading = true
				this.demoScale = 0.5 / this.displayCount
				this.getZones()
			},
			clickInvisibleButton (i, j) {
				this.selectedPlaylist = i
				this.selectedRegion = j
				console.log($('#invisible-button > button'))
				$('#invisible-button > button').click()
			},
			selectedResource (e) {
				console.log(e)
				console.log(this.selectedPlaylist, this.selectedRegion)
				console.log(this.regionList[this.selectedPlaylist][this.selectedRegion])
				this.regionList[this.selectedPlaylist][this.selectedRegion].resource = e
				this.$forceUpdate()
				this.$nextTick(x => {
					var a = document.getElementsByClassName('autoPlayMe')
					for (var i = 0; i < a.length; i++) {
						a[i].pause()
						a[i].currentTime = 0
					}
				})
			},
			groupMode () {
				let max = this.zones.reduce((t, x) => {
					if (x.group !== false) {
						console.log(x)
						if (x.group > t) {
							t = x.group
						}
					}
					return t
				}, -1)
				if (this.zones[this.selectedPlaylist].group === false) {
					this.selectedGroup = max + 1
				} else {
					this.selectedGroup = this.zones[this.selectedPlaylist].group
				}
				this.groupModeOn = !this.groupModeOn
			},
			groupToggle (val) {
				if (this.groupModeOn) {
					if (this.zones[val].group !== this.selectedGroup) {
						this.zones[val].group = this.selectedGroup
					} else {
						this.zones[val].group = false
					}
				}
			},
			groupModeOff () {
				this.groupModeOn = false
				// if (this.zones[this.selectedPlaylist].group !== false) {
				// 	this.zones[this.selectedPlaylist].group = false
				// }
				this.selectedGroup = null
			},
			prevDisplay () {
				if (this.displayNumber > 0) {
					this.displayNumber--
					this.getZones()
				}
			},
			nextDisplay () {
				if (this.displayNumber < this.displayCount - 1) {
					this.displayNumber++
					this.getZones()
				}
			},
			setActiveLayout (index) {
				this.step = 2
				if (this.layoutList[index].width % 1080 === 0) {
					this.layoutWidth = 1080
					this.layoutHeight = 1920
					this.padding = -(this.layoutHeight * (1 - this.demoScale)) + 20
					this.displayCount = this.layoutList[index].width / 1080
				} else {
					this.layoutWidth = 1920
					this.layoutHeight = 1080
					this.padding = -(this.layoutHeight * (1 - this.demoScale)) + 20
					this.displayCount = this.layoutList[index].width / 1920
				}
				this.actualWidth = this.layoutList[index].width
				this.name = this.layoutList[index].name
				this.layoutId = this.layoutList[index].layout_id
				this.getZones()
			},
			getLayouts () {
				return Signage.getLayouts(this.activeLocationId).then(response => {
					console.log(response)
					this.layoutList = response.payload.layouts
				}).catch(e => {
				})
			},
			getZones () {
				this.zones = []
				this.regionList = []
				this.regionNames = []
				return Signage.getZones(this.layoutId).then(response => {
					this.regionList = response.payload.zones.map((x, i) => {
						let obj = []
						console.log(obj)
						return obj
					})
					this.regionNames = response.payload.zones.map(x => {
						return x.label
					})
					this.zones = response.payload.zones.map((x, i) => {
						let obj = {
							width: x.width,
							height: x.height,
							z: x.z_index,
							y: x.y,
							x: x.x - (((x.x / this.layoutWidth) >> 0) * this.layoutWidth),
							actual_x: x.x,
							background: this.colorHash(x.label, x.zone_id),
							name: x.label,
							zone_id: x.zone_id,
							screen: (x.x / this.layoutWidth) >> 0,
							group: false
						}
						return obj
					})
					// this.regionList = temp.sort((a, b) => {
					// 	return parseFloat(b.z) - parseFloat(a.z)
					// })
					this.loading = false
					console.log(this.zones)
				}).then(x => {
					console.log('zones loaded')
					this.getPlaylists(this.selectedPresentation.presentation_id)
					this.$forceUpdate()
				}).catch(e => {
				})
			},
			colorHash (name, id) {
				var str = md5(id + name)
				var bytes = [] // char codes
				for (var i = 0; i < str.length; ++i) {
					var code = str.charCodeAt(i)
					bytes = bytes.concat([code])
				}
				var bytesTotal = bytes.reduce((total, x) => {
					total += x
					return total
				}, 0)
				var val = bytesTotal / bytes.length
				var normalize = val / 255
				var normalize2 = normalize * 10 / 9
				return `#${Math.floor(normalize2 * 0x1000000).toString(16).padStart(6, 0)}`
			},
			toggle () {
				this.$refs.fs.toggle()
				this.$fs.toggle(this.$el.querySelector('.layout-editor'), {
					wrap: true,
					background: 'white',
					callback: this.fullscreenChange
				})
			},
			fullscreenChange (fullscreen) {
				console.log(fullscreen)
				this.fullscreen = fullscreen
				if (fullscreen === true && this.beforeFullscreen === null) {
					console.log(this.demoScale)
					this.beforeFullscreen = this.demoScale
					this.demoScale = 1
					console.log(this.beforeFullscreen)
					let a = document.getElementsByClassName('autoPlayMe')
					for (let i = 0; i < a.length; i++) {
						a[i].play()
					}
				} else if (fullscreen === false && this.beforeFullscreen !== null) {
					this.demoScale = this.beforeFullscreen
					this.beforeFullscreen = null
					let a = document.getElementsByClassName('autoPlayMe')
					for (let i = 0; i < a.length; i++) {
						a[i].play()
					}
				}
			},
			reset () {
				this.play = false
				window.cancelAnimationFrame(this.animationStep)
				this.players = this.players.map(x => { return 0 })
				this.start()
			},
			stop () {
				this.play = false
				$('.playlist .el-slider__bar').removeClass('playing')
				window.cancelAnimationFrame(this.animationStep)
				var a = document.getElementsByClassName('autoPlayMe')
				this.regionList.map((x, i) => {
					if (x.length > 0) {
						this.players[i] = 0
					}
				})
				for (var i = 0; i < a.length; i++) {
					a[i].pause()
					a[i].currentTime = 0
				}
			},
			start () {
				var a = document.getElementsByClassName('autoPlayMe')
				for (var i = 0; i < a.length; i++) {
					a[i].pause()
					a[i].currentTime = 0
					a[i].play()
				}
				console.log(this.regionList)
				this.players = []
				this.regionList.map((x, i) => {
					if (x.length > 0) {
						this.players[i] = 0
					}
				})
				this.play = true
				let _this = this
				var startTimes
				var reset
				var baseTimes = []
				console.log(this.players)
				function startCounting () {
					startTimes = _this.players.map(x => Date.now())
					_this.animationStep = window.requestAnimationFrame(step)
					baseTimes = _this.players.map(x => x)
				}
				function step (timestamp) {
					var progress = startTimes.map((x, i) => {
						if (!isNaN(reset)) {
							startTimes[reset] = Date.now()
							reset = null
						}
						return Date.now() - x
					})
					_this.players = baseTimes.map((x, i) => x + (progress[i] / 1000))
					for (let i = 0; i < _this.players.length; i++) {
						let max = _this.regionList[i].reduce((total, x) => {
							if (x.width + x.x > total) {
								total = x.width + x.x
							}
							return total
						}, 0)

						if (_this.players[i] >= (max / _this.scale)) {
							reset = i
						}
					}
					_this.animationStep = window.requestAnimationFrame(step)
				}
				startCounting()
				$('.playlist .el-slider__bar').addClass('playing')
			},
			pause () {
				this.play = false
				window.cancelAnimationFrame(this.animationStep)
				// $('.playlist .el-slider__bar').removeClass('playing')
			},
			clickSelector (i) {
				this.selectedRegion = i
				console.log('selector')
			},
			selectPlaylist (i) {
				this.selectedPlaylist = i
				// this.playlist.forEach((x, j) => {
				// 	x.forEach((y, i) => {
				// 		this.$nextTick(() => {
				// 			document.getElementById('region-' + j + '-' + i).style.width = y.width + 'px'
				// 			document.getElementById('region-' + j + '-' + i).style.left = y.x + 'px'
				// 		})
				// 	})
				// })
			},
			update (left, width, i, j) {
			},
			deleteQueue () {
				for (let i = 0; i < this.regionList[this.selectedPlaylist].length; i++) {
					console.log(this.regionList[this.selectedPlaylist][i])
					if (this.regionList[this.selectedPlaylist][i].del === true) {
						console.log('delete')
						this.regionList[this.selectedPlaylist].splice(i, 1)
						break
					}
				}
				// for (let i = this.regionList[this.selectedPlaylist].length - 1; i > 0; i--) {
				// 	if (this.regionList[this.selectedPlaylist][i].del === false) {
				// 		this.selectedRegion = i
				// 		break
				// 	}
				// }
				// console.log(this.regionList)
			},
			deleteRegion () {
				this.regionList[this.selectedPlaylist][this.regionList[this.selectedPlaylist].length - 1].del = true
				this.deleteQueue()
				this.selectedRegion = this.regionList[this.selectedPlaylist].length - 1
			},
			addNewRegion () {
				var max = 0
				var maxw = 0
				this.regionList[this.selectedPlaylist].forEach(x => {
					if (x.x >= max && x.del === false) {
						max = x.x
						maxw = x.width
					}
				})

				let newX = max + maxw
				var obj = {
					height: 50,
					width: 200,
					x: newX,
					y: 0,
					z: 0,
					background: 'white',
					del: false
				}
				if (obj.x + obj.width > this.maxTime * this.scale) {
					obj.width = this.maxTime * this.scale - obj.x
				}
				console.log(obj.x, this.maxTime * this.scale)
				if (obj.x < this.maxTime * this.scale) {
					this.regionList[this.selectedPlaylist].push(obj)
					this.selectedRegion = this.regionList[this.selectedPlaylist].length - 1
				} else {
					this.$notify.error({
						title: 'Error',
						message: 'You cannot add any more, max time reached!'
					})
				}
			},
			onResize (x, y, width, height, index, playlist) {
				this.selectedRegion = index
				this.selectedPlaylist = playlist
				this.regionList[playlist][index].x = x
				this.regionList[playlist][index].width = width
			},
			onDrag (x, y, width, height, index, playlist) {
				this.selectedRegion = index
				this.selectedPlaylist = playlist
				this.regionList[playlist][index].x = x
				this.regionList[playlist][index].width = width
			},
			setStep (val) {
				this.step = val
			}
		},
		watch: {
			displayNumber (val) {
				this.stop()
			},
			demoScale (val) {
				this.padding = -(this.layoutHeight * (1 - this.demoScale)) + 20
			},
			scale (val) {
				this.playlist.forEach((x, j) => {
					x.forEach((y, i) => {
						y.width = (y.width / this.oldScale) * val
						// console.log(y.x, document.getElementById('region-' + j + '-' + i).style.left)
						y.x = (y.x / this.oldScale) * val
						this.$nextTick(() => {
							// console.log(document.getElementById('region-' + j + '-' + i).style)
							document.getElementById('region-' + j + '-' + i).style.left = y.x + 'px'
							document.getElementById('region-' + j + '-' + i).style.width = y.width + 'px'
						})
					})
				})
				this.oldScale = val
			}
		}
	}
</script>
<style>
.playlist .el-slider__button-wrapper {
	cursor: default !important;
	pointer-events: none !important;
}
.clickable-blue {
	pointer-events: auto!important;
	background-color:#20a0ff!important;
}
.clickable-white {
	pointer-events: auto!important;
	background-color: white!important;
}
.el-select-dropdown__item.selected {
    border: none!important;
}
.el-time-panel, .el-picker-panel, .el-select-dropdown {
	z-index: 10000 !important;
}
.imageContainer {
	background-size: contain !important;
	background-repeat: no-repeat!important;
	background-position: center!important;
}
.seethru {
	opacity:0.5!important;
}
.el-notification, .el-message {
	z-index: 99999 !important;
}
.playlist .el-slider__runway {
	position: absolute !important;
	background-color: transparent !important;
}
.playlist .el-slider__bar {
	opacity: 0;
}
.playlist .el-slider__button {
	display:none!important;
}

.playing {
	pointer-events: none!important;
	margin-top: -16px;
	height: 50px !important;
	z-index: 999 !important;
	opacity: 0.7!important;
}

.fullscreen {
	display: flex;
	justify-content: center;
	align-items: center;
}
.playlist .handle-tl, .playlist .handle-tr, .playlist .handle-tm, .playlist .handle-bm, .handle-ml{
	display:none !important;
}

.playlist .handle-mr {
	z-index: 9999999;
	right: -6px !important;
	top: auto!important;
	margin-top:0px !important;
	height: 15px !important;
	width: 5px !important;
}

.playlist .region:hover {
	cursor: default;
}
.playlist .handle-mr:hover, .playlist .handle-ml:hover {
	cursor: col-resize;
}
.playlist .handle-br {
	display:none !important;
	bottom: 0 !important;
	right: 0 !important;
}
.playlist .handle-bl {
	display:none !important;
	bottom: 0 !important;
	left: 0 !important;
} 
</style>
<style scoped>
.floatLeft {
	float:left !important;
}
.groupHover {
	cursor:cell;
}
.invisible {
	display:none!important;
}
/*.selected-playlist {
	background-color: #bdc3c7 !important;
}*/
.selected-region {
	background-color: #2ecc71!important;
}
.selected-playlist-text {
	/*border-style:outset;*/
	opacity: 1 !important;
}

.demo-region {
	/*opacity:0.8;*/
	justify-content:center;
	display:flex;
	align-items:center;
	text-align:center;
	/*border: 2px dotted grey;*/
/*	background-color:lightgrey;*/
}
#draggable { width: 150px; height: 150px; padding: 0.5em; }
.flex-center {
	width:100%;
	display:flex;
	justify-content:center;
	align-items:center;
	flex-wrap:wrap;
	text-align:center;
}
.flex-center > div {
	width: 100%;
	margin: 5px;
}
.el-button+.el-button {
    margin-left: 0px !important;
}
.selected {
	border: 3px dotted white;
}
</style>


// WEBPACK FOOTER //
// Playlist.vue?61ee74fb